export const VANITA_VIEWER = "vanita_viewer";